import { render, staticRenderFns } from "./coffee-search.vue?vue&type=template&id=68404bb8&scoped=true&"
import script from "./coffee-search.vue?vue&type=script&lang=js&"
export * from "./coffee-search.vue?vue&type=script&lang=js&"
import style0 from "./coffee-search.vue?vue&type=style&index=0&id=68404bb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68404bb8",
  null
  
)

export default component.exports